import { TBCPortal } from './tbc-portal';

export class TBCPortalSerializer {

  fromJson(json: any): TBCPortal {

    const tbc = new TBCPortal();
    if (typeof json.success !== 'undefined' && typeof json.data !== 'undefined') {
      tbc.success = json.success;
      tbc.data = json.data;
      return tbc;
    } else {
      tbc.id = json.id;
      tbc.tbc = json.tbc;
      tbc.totvs_user = json.totvs_user;
      tbc.totvs_pass = json.totvs_pass;
      tbc.use_methods_without_license = json.use_methods_without_license;
      tbc.use_totvs_oracle = json.use_totvs_oracle;
      tbc.use_methods_rest = json.use_methods_rest;
      return tbc;
    }
  }

  toJson(tbc: TBCPortal): any {
    return {
      id: tbc.id,
      tbc: tbc.tbc,
      totvs_user: tbc.totvs_user,
      totvs_pass: tbc.totvs_pass,
      use_methods_without_license: tbc.use_methods_without_license,
      use_totvs_oracle: tbc.use_totvs_oracle,
      use_methods_rest: tbc.use_methods_rest
    };
  }
}